import Feeds from '@/pages/Feeds'

export default {
  path: '/feeds',
  name: 'Feeds',
  component: Feeds,
}


// WEBPACK FOOTER //
// ./src/router/feeds.js